import { render, staticRenderFns } from "./LeatestCompetition.vue?vue&type=template&id=9cea4bbc&"
import script from "./LeatestCompetition.vue?vue&type=script&lang=js&"
export * from "./LeatestCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports